import React from "react";
import { makeStyles, Box } from "@material-ui/core";
import CarrierInfo from "../atoms/CarrierInfo";
import FlightItinerary from "./FlightItinerary";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  ticketTemplate: {
    margin: "30px 0",
    position: "relative",
    [down("xs")]: {
      margin: "15px 0",
    },
  },
}));

const TicketTemplate = ({ ticketInfo, airlines, airports }) => {
  const { ticketTemplate } = useStyles();
  return (
    <Box display="flex" className={ticketTemplate}>
      <CarrierInfo carrierInfo={ticketInfo?.carrier} operatedBy={ticketInfo?.operating_carrier_text} airlines={airlines} />
      <FlightItinerary
        airports={airports}
        departure={ticketInfo?.departure}
        arrival={ticketInfo?.arrival}
        duration={ticketInfo?.duration}
        meal={ticketInfo?.meal}
        layover={ticketInfo?.layover}
        carrierInfo={ticketInfo?.carrier}
        operatedBy={ticketInfo?.operating_carrier_text}
      />
    </Box>
  );
};

export default TicketTemplate;
